export default __webpack_public_path__ + "static/media/cable.9f1a8f86.png";